// extracted by css-extract-rspack-plugin
export default {"contactSalesLink":"contactSalesLink-M4r_PA"};